module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    attrs: {
      "id": "banner"
    }
  }, _vm._l((_vm.bannerSlides), function(bannerSlide, index) {
    return _c('div', {
      staticClass: "banner-slide",
      attrs: {
        "img": bannerSlide.img
      }
    }, [_c('div', {
      staticClass: "slide-info"
    }, [_c('h1', [_vm._v(_vm._s(bannerSlide.header))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(bannerSlide.text))]), _vm._v(" "), (bannerSlide.button != null) ? _c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.bbl(bannerSlide.href)
        }
      }
    }, [_vm._v(_vm._s(bannerSlide.button))]) : _vm._e()])])
  })), _vm._v(" "), _c('div', {
    staticClass: "info-container"
  }, _vm._l((_vm.infoItems), function(infoItem) {
    return _c('div', {
      staticClass: "info-item col-md-4"
    }, [_c('div', {
      staticClass: "info-icon"
    }, [_c('img', {
      attrs: {
        "src": 'static/images/' + infoItem.img
      }
    })]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(infoItem.header))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(infoItem.text))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "featured-products"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.fproducts), function(fproduct) {
    return _c('router-link', {
      key: fproduct.code,
      staticClass: "fproduct col-xs-12 col-sm-6 col-md-3",
      attrs: {
        "to": '/products/product/' + fproduct.code
      }
    }, [_c('img', {
      attrs: {
        "src": 'static/images/products/' + fproduct.code + '.jpg',
        "alt": fproduct.name
      }
    }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(fproduct.name))]), _vm._v(" "), (!_vm.disabled) ? _c('p', [_vm._v("Php " + _vm._s(_vm.formatMoney(fproduct.price)))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(fproduct.categoryName))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearboth"
  }), _vm._v(" "), _c('div', {
    staticClass: "cta-section",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/products"
    }
  }, [_vm._v("View All Products")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "link-section"
  }, [_c('h1', [_vm._v("With over 250 branches across the Philippines")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/locations"
    }
  }, [_vm._v("View Locations")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fp-header"
  }, [_c('h1', [_vm._v("Our Featured Products")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-337b224f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 146
// module chunks = 0